export function expandBackUrl(backUrl: string, status: string, statusMessage: string, manCode: string, version?: number): string {
  const url = new URL(backUrl, location.href)

  url.searchParams.append('status', status)
  url.searchParams.append('statusMessage', statusMessage)
  url.searchParams.append('manCode', manCode)
  if (version !== undefined) {
    url.searchParams.append('version', version.toString())
  }

  return url.toString()
}
